function tPreloadImgs (imgs) {
  if (!imgs || imgs.length === 0) {
    return
  }
  imgs.forEach(function (imgUrl) {
    var img = new Image();
    if (img.complete) {
      //图片已经加载过了，可以使用图片
    } else {
      img.onload = function() {
        //图片首次加载完成，可以使用图片
      };
    }
    img.src = imgUrl;
  })
}

// 防抖
function debounce(handle, delay) {
  var timer;
  return function (event) {
    clearTimeout(timer);
    timer = setTimeout(handle.bind(this, event), delay);
  };
}

// 节流
function throttle(handle, delay) {
  let start = Date.now()
  return function(event) {
    const now = Date.now()
    if (now - start >= delay) {
      handle.call(this, event)
      start = Date.now()
    }
  }
}

function showToast (options) {
  const _options = Object.assign({}, {
    type: 'info',
    text: '',
    duration: 1200
  }, options)

  if (showToast[_options.text]) {
    return
  }
  showToast[_options.text] = true

  const toast = document.createElement('div')
  toast.className = 'toast'
  toast.innerHTML = `<span>${_options.text}</span>`
  document.body.appendChild(toast)
  setTimeout(() => {
    document.body.removeChild(toast)
    delete showToast[_options.text]
  }, _options.duration)
}

function getQueryVariable (variable) {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const [ key, value ] = vars[i].split('=')
    if (key === variable) {
      return value
    }
  }
  return
}

function isVisibleInWindow (element, baseTopNum = 0) {
  if (!element || typeof element.getBoundingClientRect !== 'function') {
    return false
  }
  const rect = element.getBoundingClientRect()
  return rect.top <= baseTopNum && rect.bottom > baseTopNum
}